import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, Col, Label, Row, UncontrolledTooltip } from "reactstrap";
import { AvInput, AvField, AvGroup, AvFeedback } from 'availity-reactstrap-validation';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";

import {
    getGiftCardProviders,
    getRestaurantGiftCardProviderSettings,
    saveRestaurantGiftCardProviderSettings,
    resetRestaurantGiftCardProviderSettings,
    loadTenderTypeMapping
} from "../../../../actions";

class GiftCardProviderScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            settings: {},
            fields: {},
            type: {
                id: '',
                value: '',
                template: ''
            },
            toSaveGiftCardProvider: false,
            toResetGiftCardProvider: false,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        this.props.getGiftCardProviders()
        if (this.props.restaurantId) {
            this.props.getRestaurantGiftCardProviderSettings(this.props.restaurantId);
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.restaurantId !== this.props.restaurantId) {
            this.props.getRestaurantGiftCardProviderSettings(this.props.restaurantId);
        }

        if (this.props.giftCardProvider.restaurantGiftCardProvider &&
            prevProps.giftCardProvider.restaurantGiftCardProvider !== this.props.giftCardProvider.restaurantGiftCardProvider) {
            {
            this.addSettingsToState(this.props.giftCardProvider.restaurantGiftCardProvider,
                () => {
                    this.addFieldsToState(this.props.giftCardProvider.restaurantGiftCardProvider.type.template, true)
                });
            }
        }
    }

    saveGiftCardProviderSettings = () => {
        if (this.state.toSaveGiftCardProvider) {
            let data = {
                settings: JSON.stringify({
                    password: this.state.fields.password,
                    userId: this.state.fields.userId,
                    mainUrl: this.state.fields.mainUrl,
                    secondaryUrl: this.state.fields.secondaryUrl
                }),
                type:  {
                    id: this.state.type.id
                } 
            };
            this.props.saveRestaurantGiftCardProviderSettings(this.props.restaurantId, data, () => {

                this.props.loadTenderTypeMapping(this.props.restaurantId);
            });
            this.setState({
                ...this.state,
                toSaveGiftCardProvider: false,
                toResetGiftCardProvider: false
            });
        } else if (this.state.toResetGiftCardProvider) {
            this.props.resetRestaurantGiftCardProviderSettings(this.props.restaurantId, () => {

                this.props.loadTenderTypeMapping(this.props.restaurantId);
            });
            this.setState({
                ...this.state,
                toSaveGiftCardProvider: false,
                toResetGiftCardProvider: false
            });
        }
    };

    addSettingsToState = (restaurantGiftCardProvider, callback) => {
        this.setState({
            ...this.state,
            type: restaurantGiftCardProvider.type,
            settings: JSON.parse(restaurantGiftCardProvider.settings)
        }, callback);
    };

    selectGiftCardProvider = ({ target }) => {
        for (let i = 0; i < this.props.giftCardProvider.giftCardProviders.length; i++) {

            let giftCardProvider = this.props.giftCardProvider.giftCardProviders[i];

            if (giftCardProvider.id === Number(target.value)) {
                this.setState({
                    ...this.state,
                    settings: {},
                    fields: {},
                    type: giftCardProvider
                }, () => {
                   this.addFieldsToState(giftCardProvider.template, false);
                });
                break;
            }
        }
    };

    addFieldsToState = (template, componentDidMount) => {
        let fieldsWithValue = {};
        this.getFieldsFromString(template).split(",").map((field) => {
            fieldsWithValue = { ...fieldsWithValue, [field]: componentDidMount ? this.state.settings[field] : '' };
        });

        this.setState({
            ...this.state,
            fields: fieldsWithValue,
            toSaveGiftCardProvider: !componentDidMount,
            toResetGiftCardProvider: false,
        });
    };

    getFieldsFromString(stringOfFields) {
        return stringOfFields.replace(/"/g, "").replace(/\[/g, "").replace(/]/g, "").replace(/ /g, "").replace(/{/g, "").replace(/}/g, "");
    }

    renderGiftCardProviderSelect() {
        const { fieldContainer, inputGroupStyle, labelStyle, inputStyle } = styles;

        return (
            <div style={fieldContainer}>
                <AvGroup style={inputGroupStyle}>
                    <Label style={labelStyle}>{i18n.t('screens:giftCardProviderScreen.giftCardProvider')}</Label>
                    <AvGroup style={inputStyle}>
                        <AvField type="select" name="id" id="giftCardProvider"
                            value={this.state.type.id}
                            onChange={this.selectGiftCardProvider}
                        >
                            <option disabled value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                            {this.props.giftCardProvider.giftCardProviders.map((item, i) => {
                                return (<option value={item.id} id={item.id} key={i}>{item.value}</option>)
                            })}
                        </AvField>
                    </AvGroup>
                </AvGroup>
                {this.renderResetButton()} 
                {this.state.toSaveGiftCardProvider || this.state.toResetGiftCardProvider ? this.renderSaveReminder() : null} 
            </div>
        );
    }

    renderSaveReminder() {
        const { reminderText } = styles;
        return (
            <p style={reminderText}>{i18n.t('common:validations.saveWarningMsg')}</p>
        );
    }

    renderResetButton() {
        return (
            <Button style={{ marginTop: 9 }} color="primary" onClick={this.resetGiftCardSettings}>
                {i18n.t('common:buttons.reset')}
            </Button>
        );
    }

    resetGiftCardSettings = () => {
        this.clearGiftCardSelection();
    }

    clearGiftCardSelection() {
        this.setState({
            ...this.state,
            settings: {},
            fields: {},
            type: {
                id: '',
                value: '',
                template: ''
            },
            toSaveGiftCardProvider: false,
            toResetGiftCardProvider: true

        });
    }

    renderSurveyPartnerFields() {
        const { inputGroupStyle, labelStyle, inputStyle, fieldContainer } = styles;
        return (
            <div style={fieldContainer}>
                {Object.keys(this.state.fields).map((key) => {
                    return (
                        <AvGroup style={inputGroupStyle}>
                            <Label style={labelStyle}>{i18n.t(`screens:giftCardProviderScreen.fields.${key}`)}</Label>
                            <AvInput style={inputStyle}
                                type={key === 'password' ? 'password' : 'text'} 
                                name={key}
                                value={this.state.fields[key]}
                                onChange={this.updateFieldValue}
                                errorMessage={i18n.t('common:validations.errorMsg')}
                                required>
                            </AvInput>
                            {/* <AvFeedback>
                            {i18n.t('common:validations.errorMsg')}
                            </AvFeedback> */}
                        </AvGroup>
                    )
                })}
            </div>
        );
    };

    updateFieldValue = ({ target }) => {
        this.setState({
            ...this.state,
            toSaveGiftCardProvider: true,
            fields: {
                ...this.state.fields,
                [target.name]: target.value
            }
        });
    };

    renderInfoMessage() {
        return (
            <div style={{ display: 'flex', paddingRight: 25 }}>
                <span id={'infoIcon'}>
                    <MaterialIcon icon='info' color="#0288D1" size={22}/>&nbsp; 
                </span>
                <UncontrolledTooltip placement="top" target={'infoIcon'}>
                    {i18n.t('screens:restaurantsSettingsContainer.giftCardsNotSupportingAndromeda')}
                    <br/>
                    {i18n.t('screens:restaurantsSettingsContainer.revelPosRequiresConfigForGiftCards')}
                </UncontrolledTooltip>
            </div>
        )
    }

    render() {
        const { headerStyle, headerTitle, hint } = styles;

        return (
            <Fragment>
            <Col className="sectionStyle">
            <Row style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div style={headerStyle}>
                        <MaterialIcon icon="card_giftcard" size={20} color='#0288d1' />
                        <span style={headerTitle}>{i18n.t('screens:giftCardProviderScreen.heading')}</span>
                    </div>
                        {this.renderInfoMessage()}
                </Row>
                <Row>
                    <div style={{ width: '100%' }}>
                        {this.renderGiftCardProviderSelect()}
                        {this.renderSurveyPartnerFields()} 
                    </div>
                </Row>
            </Col>
            </Fragment >
        );
    }
};

const mapStateToProps = state => {
    return {
        restaurantId: state.restaurant.id,
        giftCardProvider: state.giftCardProvider
    }
}
export default connect (mapStateToProps, {
    getGiftCardProviders,
    getRestaurantGiftCardProviderSettings,
    saveRestaurantGiftCardProviderSettings,
    resetRestaurantGiftCardProviderSettings,
    loadTenderTypeMapping
}) (GiftCardProviderScreen) ;

const styles = {
    inputGroupStyle: {
        width: '50%',
        padding: "10px 20px 0 20px",
        display: 'flex',
        justifyContent: 'space-between'
    },
    labelStyle: {
        width: '30%',
        paddingTop: 10
    },
    inputStyle: {
        width: '60%'
    },
    fieldContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    headerStyle: {
        paddingLeft: 0,
        borderBottom: "1px solid rgb(222, 226, 230)",
        marginBottom: 15,
        color: '#0088d1',
        width: 400
    },
    reminderText: {
        color: '#dc3545',
        fontSize: 13,
        position: 'absolute',
        right: 20,
        paddingTop: 20
    },
    headerTitle: {
        marginLeft: 5
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/GiftCardProviderScreen.js